module.exports = __webpack_public_path__ + "img/print.ac51d033.svg";